/**
 * 📥 만료예정 상태표 — 25일에 딜등록 메시지방에 올라가는 엑셀을 **누른 순간의 자료로** 받는다 (v2.219.0 · 2026-09-30)
 *
 * 사용자: 「딜등록 메뉴에서 만료예정인 건들 상태를 엑셀로 내려받기 버튼을 만들어줘. 내려받는 내용은 25일에 표로
 *   만들어서 엑셀파일로 메신저에 띄우는 그 형태의 엑셀파일을 버튼 누른 시점의 데이터로 만들어서 받아주면 되」
 *
 * · 서버가 25일 발송과 **같은 조립 함수**로 만든다(GET /deal-registrations/monthly-notice/preview?kind=d25) —
 *   ⛔화면에서 따로 만들지 말 것(모양이 갈린다).
 * · 들어가는 딜 = [⏰ 만료 임박] 과 같다 — 진행 중 탭 · 승인대기 제외 · 연장 마감 30일 안(지난 것 포함).
 * · 프로젝트정보 = 지난 25일 안내 다음 날부터 적은 업데이트(= 다음 25일 파일과 같은 기간)의 **한글**(날짜 붙여) ·
 *   옆 칸 「프로젝트정보(영문)」 = 같은 업데이트의 **영문만**(날짜 없이 · 인포트렌드 사이트에 칸째 복사해 붙여 넣기용).
 *   업데이트가 없으면 On-going 만 「계속 제안중」(영문 「Request for extend. / Ongoing proposal to customer」), 그 밖의 상태는 빈칸.
 * · 옛 자리: [🔔 월간 안내 ▼] 안 「👁 25일 상태표(엑셀) 받기」 — 이 단추로 옮겼다(메뉴 속이라 눈에 안 띄었다).
 */

import { useState } from 'react';
import { fetchMonthlyPreview } from '../lib/deal-registration-api';

export function DealStatusXlsxButton({
  onNotice,
}: {
  /** 결과 한 줄 — 페이지 위 알림 띠에 보인다 */
  onNotice: (msg: string) => void;
}): React.JSX.Element {
  const [busy, setBusy] = useState(false);

  const download = async (): Promise<void> => {
    setBusy(true);
    try {
      const { blob, name, count } = await fetchMonthlyPreview('d25');
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 10_000);
      const n = count === null ? '' : ` · ${count}건`;
      onNotice(`📥 내려받았습니다 — 「${name}」${n} · 25일에 메시지방에 올라가는 엑셀과 같은 모양(지금 자료)입니다.`);
    } catch (e) {
      onNotice(`⚠ 만료예정 상태표를 만들지 못했습니다 — ${(e as Error).message}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={() => { void download(); }}
      disabled={busy}
      data-deal-status-xlsx
      title="25일에 딜등록 메시지방에 올라가는 상태표(엑셀)를 지금 자료로 받습니다 — [⏰ 만료 임박] 딜 그대로 · 신청일 · 상태 · 영업담당자 · Tier2 · End-user · 프로젝트정보(지난 25일 안내 뒤 적은 업데이트의 한글) · 프로젝트정보(영문)(영문만 · 날짜 없이 — 인포트렌드 사이트에 붙여 넣기용). 업데이트가 없으면 On-going 만 「계속 제안중」, 그 밖의 상태는 빈칸."
      className="btn btn-warning"
    >
      {busy ? '만드는 중…' : '📥 만료예정 상태표'}
    </button>
  );
}
